import { devUrls } from "./dev-urls.const.ts";
import { stageUrls } from "./stage-urls.const.ts";
import { prodUrls } from "./prod-urls.const.ts";
import { Urls } from "./urls.interface.ts";

const mode = import.meta.env.MODE;
let urls: Urls;

if (mode === "development") {
  urls = devUrls;
} else if (mode === "staging") {
  urls = stageUrls;
} else {
  urls = prodUrls;
}

export { urls };
